//Helper.js
import axios from "axios";
import { getToken, isValidToken, removeToken } from "./tokenService";

export const BASE_URL = 'http://localhost:8080';

export const myAxios = axios.create({
    baseURL: BASE_URL,
});

// Request interceptor
myAxios.interceptors.request.use(config => {
    const token = getToken();
    if (token && isValidToken()) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Response interceptor
myAxios.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            removeToken();
            // Redirect to login
        }
        return Promise.reject(error);
    }
);